export const validateInputs = (phoneNumber, message) => {
    if (!phoneNumber.trim()) {
      return 'Please enter a phone number';
    }
    
  };
  